import { render, staticRenderFns } from "./CorrectiveList.vue?vue&type=template&id=6eecf2b9"
import script from "./CorrectiveList.vue?vue&type=script&lang=js"
export * from "./CorrectiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports